import React, { memo } from '../../lib/teact/teact';
import { getActions, withGlobal } from '../../global';

import type { UserToken } from '../../global/types';

import { selectTokenInfoUserTokens } from '../../global/selectors';

import useHistoryBack from '../../hooks/useHistoryBack';
import useLang from '../../hooks/useLang';
import useLastCallback from '../../hooks/useLastCallback';

import TokenSelector from '../common/TokenSelector';
import SettingsHeader from './SettingsHeader';

import styles from './Settings.module.scss';

interface OwnProps {
  isActive?: boolean;
  onBackClick: NoneToVoidFunction;
}

interface StateProps {
  searchTokens?: UserToken[];
}

function SettingsTokenList({
  isActive,
  onBackClick,
  searchTokens,
}: OwnProps & StateProps) {
  const { addToken } = getActions();

  const lang = useLang();

  const handleTokenSelect = useLastCallback((token: UserToken) => {
    addToken({ token });
  });

  useHistoryBack({
    isActive,
    onBack: onBackClick,
  });

  return (
    <div className={styles.slide}>
      <SettingsHeader title={lang('Select Token')} onBackClick={onBackClick} />
      <div className={styles.tokenListContent}>
        <TokenSelector
          isActive={isActive}
          shouldHideMyTokens
          shouldHideNotSupportedTokens
          searchTokens={searchTokens}
          noHeader
          searchClassName={styles.tokenListSearch}
          onTokenSelect={handleTokenSelect}
          onBack={onBackClick}
          onClose={onBackClick}
        />
      </div>
    </div>
  );
}

export default memo(withGlobal<OwnProps>((global): StateProps => {
  return {
    searchTokens: selectTokenInfoUserTokens(global),
  };
})(SettingsTokenList));
